import React from 'react';
import { motion } from 'framer-motion';

const IntroAnimation = () => {
  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: '#000' }}
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <div className="relative flex flex-col items-center">
        {/* Symbol on top, wordmark below — tight stack */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.2, ease: "circOut" }}
          className="relative z-10 flex flex-col items-center"
        >
          <img
            src={`${process.env.PUBLIC_URL}/logo/main-logo.png`}
            alt=""
            aria-hidden="true"
            style={{ height: 160, width: 160, objectFit: 'contain' }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/logo/minimalist-dark.png`}
            alt="InterNull"
            style={{ height: 40, objectFit: 'contain', marginTop: 12 }}
          />
        </motion.div>

        {/* Loading Bar */}
        <motion.div
          className="absolute -bottom-16 h-1 w-64 overflow-hidden"
          style={{ backgroundColor: '#262626' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          <motion.div
            className="h-full bg-white"
            initial={{ x: "-100%" }}
            animate={{ x: "0%" }}
            transition={{ delay: 1.2, duration: 1.2, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default IntroAnimation;
